<template>
  <v-layout justify-start align-center align-content-center>
    <v-flex xs5 style="display: flex">
      <v-menu
        v-model="startMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
      >
        <template v-slot:activator="{ on }">
          <span class="creative-schedule">
            <span v-if="readOnly">{{ startTimeText }}</span>
            <v-text-field
              v-else-if="isStartTimeEditable"
              v-on="on"
              v-model="startTimeText"
              :disabled="disabled"
              prepend-icon="event"
              class="pa-0 ma-0"
              style="width: 110px"
              hide-details
              readonly
            />
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ startTimeText }}</span>
              </template>
              <span>期間消化を開始したため変更できません。</span>
            </v-tooltip>
          </span>
        </template>
        <template>
          <v-radio-group
            v-if="isDuringDelivery"
            v-model="useCampaignBudgetStartTime"
            @change="onChangeStartTime"
            style="background-color: white"
          >
            <v-radio
              @click="onChangeStartTime(true)"
              :value="true"
              label="配信開始日時"
            />
          </v-radio-group>
          <v-date-picker
            v-model="startDate"
            :day-format="date => new Date(date).getDate()"
            :min="cbStartDate"
            :max="cbEndDate"
            @input="startMenu = false"
            @change="onChange()"
            no-title
            scrollable
            locale="ja"
          />
        </template>
      </v-menu>
      <div v-if="startTime" class="creative-schedule" style="margin-left: 10px">
        <span v-if="readOnly">{{ startDateTime }}</span>
        <v-select
          v-else-if="isStartTimeEditable"
          v-model="startDateTime"
          :disabled="disabled"
          :items="hourListStart"
          @change="onChange()"
          class="pa-0 ma-0"
          style="width: 60px"
          hide-details
        />
      </div>
    </v-flex>
    <v-flex style="text-align: center;" xs1>〜</v-flex>
    <v-flex xs5 style="display: flex">
      <v-menu
        v-model="endMenu"
        :close-on-content-click="false"
        :nudge-right="40"
        lazy
        transition="scale-transition"
        offset-y
        full-width
        style="background-color: white"
      >
        <template v-slot:activator="{ on }">
          <span class="creative-schedule">
            <span v-if="readOnly">{{ endTimeText }}</span>
            <v-text-field
              v-else-if="isEndTimeEditable"
              v-on="on"
              v-model="endTimeText"
              :disabled="disabled"
              prepend-icon="event"
              class="pa-0 ma-0"
              style="width: 110px"
              hide-details
              readonly
            />
            <v-tooltip v-else top>
              <template v-slot:activator="{ on }">
                <span v-on="on">{{ endTimeText }}</span>
              </template>
              <span>配信スケジュールが終了しているため変更できません。</span>
            </v-tooltip>
          </span>
        </template>
        <v-radio-group
          v-model="useCampaignBudgetEndTime"
          @change="onChangeEndTime($event)"
          style="background-color: white"
        >
          <v-radio
            @click="onChangeEndTime(true)"
            :value="true"
            label="配信終了日時"
          />
        </v-radio-group>
        <v-date-picker
          v-model="endDate"
          :day-format="date => new Date(date).getDate()"
          :min="cbStartDateMinLimit"
          :max="cbEndDate"
          @input="endMenu = false"
          @change="onChange()"
          no-title
          scrollable
          locale="ja"
        />
      </v-menu>
      <span v-if="endTime" class="creative-schedule" style="margin-left: 10px">
        <span v-if="readOnly">{{ endDateTime }}</span>
        <v-select
          v-else-if="isEndTimeEditable"
          v-model="endDateTime"
          :disabled="disabled"
          :items="hourListEnd"
          @change="onChange()"
          class="pa-0 ma-0"
          style="width: 60px"
          hide-details
        />
      </span>
    </v-flex>
  </v-layout>
</template>

<script>
import dayjs from 'dayjs'
export default {
  name: 'EditCreativeScheduleRangeForm',
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    campaignBudget: {
      type: Object,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // datepicker表示制御用
      startMenu: false,
      endMenu: false,
      hourListStart: [],
      hourListEnd: [],
    }
  },
  computed: {
    useCampaignBudgetStartTime: {
      get() {
        return this.startTime === undefined
      },
      set(boolean) {
        if (boolean) {
          this.startTime = undefined
        }
      },
    },
    useCampaignBudgetEndTime: {
      get() {
        return this.endTime === undefined
      },
      set(boolean) {
        if (boolean) {
          this.endTime = undefined
        }
      },
    },
    isStartTimeEditable() {
      return this.startTime
        ? dayjs(this.startTime).isAfter(dayjs())
        : this.isDuringDelivery
    },
    isEndTimeEditable() {
      const now = dayjs()
      return this.endTime
        ? dayjs(this.endTime).isAfter(now)
        : dayjs(this.campaignBudget.endTime).isAfter(now)
    },
    isDuringDelivery() {
      return dayjs(this.campaignBudget.startTime).isAfter(dayjs())
    },
    startTime: {
      get() {
        return this.value.startTime
      },
      set(dateTime) {
        const now = dayjs()
        if (dayjs(dateTime).isBefore(now)) {
          const hourTime = Number(now.hour()) + 1
          this.startTime = `${this.cbStartDateMinLimit} ${hourTime}:00:00`
        } else {
          this.value.startTime = dateTime
        }
        this.initTimeList()
      },
    },
    endTime: {
      get() {
        return this.value.endTime
      },
      set(dateTime) {
        this.value.endTime = dateTime
      },
    },
    startTimeText() {
      return this.startTime ? this.startDate : '配信開始日時'
    },
    endTimeText() {
      return this.endTime ? this.endDate : '配信終了日時'
    },
    cbStartTime() {
      return this.campaignBudget.startTime
    },
    cbEndTime() {
      return this.campaignBudget.endTime
    },
    cbStartDate() {
      return dayjs(this.cbStartTime).format('YYYY-MM-DD')
    },
    cbEndDate() {
      return dayjs(this.cbEndTime).format('YYYY-MM-DD')
    },
    cbStartDateMinLimit() {
      const now = dayjs()
      return (dayjs(this.cbStartTime).isAfter(now)
        ? dayjs(this.cbStartTime)
        : now
      ).format('YYYY-MM-DD')
    },
    startDate: {
      get() {
        return this.startTime
          ? dayjs(this.startTime).format('YYYY-MM-DD')
          : dayjs(this.cbStartTime).format('YYYY-MM-DD')
      },
      set(date) {
        this.startTime = `${date} ${this.startDateTime}:00`
      },
    },
    startDateTime: {
      get() {
        return this.startTime
          ? dayjs(this.startTime).format('HH:mm')
          : dayjs(this.cbStartTime).format('HH:mm')
      },
      set(time) {
        this.value.startTime = `${this.startDate} ${time}:00`
      },
    },
    endDate: {
      get() {
        return this.endTime
          ? dayjs(this.endTime).format('YYYY-MM-DD')
          : dayjs(this.cbEndTime).format('YYYY-MM-DD')
      },
      set(date) {
        const endTime =
          this.value.startDate === date ? '23:59' : this.endDateTime
        this.value.endTime = `${date} ${endTime}:59`
      },
    },
    endDateTime: {
      get() {
        return this.endTime
          ? dayjs(this.endTime).format('HH:mm')
          : dayjs(this.cbEndTime).format('HH:mm')
      },
      set(time) {
        this.endTime = `${this.endDate} ${time}:59`
      },
    },
    startHourNumber() {
      return Number(this.startDateTime.substr(0, 2))
    },
    endHourNumber() {
      return Number(this.endDateTime.substr(0, 2))
    },
  },
  mounted() {
    this.initTimeList()
  },
  methods: {
    onChangeStartTime(status) {
      if (status) {
        this.startMenu = false
        this.startTime = undefined
      }
    },
    onChangeEndTime(status) {
      if (status) {
        this.endMenu = false
        this.endTime = undefined
      }
    },
    onChange() {
      this.$emit('change')
      this.initTimeList()
    },
    initTimeList() {
      const now = dayjs()
      const tempListStart = []
      const tempListEnd = []
      const nowDate = now.format('YYYY-MM-DD')
      const startTimeStartHour =
        this.startDate === nowDate ? Number(now.hour()) + 1 : 0
      const isSameDate = this.startDate === this.endDate
      const endHour = isSameDate ? this.endHourNumber : 24
      for (let i = startTimeStartHour; i < endHour; i++) {
        tempListStart.push({
          text: this.zeroPadding(i) + ':00',
          value: this.zeroPadding(i) + ':00',
        })
      }
      const endTimeStartHour =
        this.endDate === now.format('YYYY-MM-DD')
          ? Number(now.format('HH')) + 1 // 当日過ぎた時間は除外
          : isSameDate
          ? this.startHourNumber + 1 // 開始日時は以前は設定できない
          : 0 // 全て出す
      for (let i = endTimeStartHour; i < 24; i++) {
        tempListEnd.push({
          text: this.zeroPadding(i) + ':59',
          value: this.zeroPadding(i) + ':59',
        })
      }
      this.hourListStart = tempListStart
      this.hourListEnd = tempListEnd
    },
    zeroPadding(num, length = 2) {
      return ('0' + num).slice(-length)
    },
  },
}
</script>

<style>
.creative-schedule .v-input {
  font-size: 12px;
}
</style>
